import { useEffect, useRef } from 'react';

const useOuterClick = <E extends Element>(onClick: (e: MouseEvent) => void) => {
  const ref = useRef<E | null>(null);

  useEffect(() => {
    const clickHandler = (event: MouseEvent) => {
      if (!ref.current?.contains(event.target as E)) {
        onClick(event);
      }
    };

    document.addEventListener('click', clickHandler);
    return () => {
      document.removeEventListener('click', clickHandler);
    };
  }, [onClick]);

  return ref;
};

export default useOuterClick;
